import actions from "./actions";

export default {
  namespaced: true,
  state: {
    nfts: [],
    totalNtfs: null,
    units: [],
    dataLoading: false
  },

  getters: {
    nfts: state => {
      return state.nfts;
    },

    totalNtfs: state => {
      return state.totalNtfs;
    },

    units: state => {
      return state.units;
    },

    dataLoading: state => {
      return state.dataLoading;
    }
  },

  mutations: {
    setNfts(state, nfts) {
      state.nfts = nfts;
    },

    setTotalNtfs(state, totalNtfs) {
      state.totalNtfs = totalNtfs;
    },

    setUnits(state, units) {
      state.units = units;
    },

    setDataLoading(state, dataLoading) {
      state.dataLoading = dataLoading;
    }
  },

  actions
};
